/** Sets or clears the dynamic favicon (falls back to index.html default when cleared). */
export function setFavicon(url: string | null | undefined): void {
  const defaultUrl = '/favicon.ico'
  const targetUrl = url || defaultUrl

  // Find all favicon link tags (e.g., rel="icon" or rel="shortcut icon")
  const links = document.querySelectorAll("link[rel*='icon']") as NodeListOf<HTMLLinkElement>

  if (links.length > 0) {
    links.forEach((link) => {
      link.href = targetUrl
      // Update or clear type attribute to prevent rendering issues (e.g. SVG vs ICO vs PNG)
      if (targetUrl.endsWith('.svg')) {
        link.type = 'image/svg+xml'
      } else if (targetUrl.endsWith('.png')) {
        link.type = 'image/png'
      } else if (targetUrl.endsWith('.ico')) {
        link.type = 'image/x-icon'
      } else {
        link.removeAttribute('type')
      }
    })
  } else {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = targetUrl
    document.head.appendChild(link)
  }
}

/** Sets the base document title (page wrappers may append segments). */
export function setBaseDocumentTitle(title: string): void {
  document.title = title
}
